import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  WardInformationComponent,
  StakeInformationComponent,
  LocalStudentManagementComponent,
  WardGroupsComponent,
  WardGroupAssignmentsLookupComponent,
  WardGroupAssignmentsComponent,
  WardDirectoryComponent,
  EmailComponent
} from '../leader';
import {
  CampusUnitsCommunicationsComponent,
  NewQuestionDialogComponent,
  NewSectionDialogComponent
} from '../admin';
import { HasChangesGuard } from '../shared';

const routes: Routes = [
  {
    path: 'ward',
    component: WardInformationComponent,
    canDeactivate: [HasChangesGuard],
    data: { title: 'Update Ward Information' }
  },
  {
    path: 'stake',
    component: StakeInformationComponent,
    canDeactivate: [HasChangesGuard],
    data: { title: 'Update Stake Information' }
  },
  {
    path: 'groups',
    component: WardGroupsComponent,
    canDeactivate: [HasChangesGuard],
    data: { title: 'Manage Ward Groups' }
  },
  {
    path: 'groups/assignments',
    component: WardGroupAssignmentsLookupComponent,
    data: { title: 'Ward Group Assignments' },
    children: [
      {
        path: ':sessionNumber',
        component: WardGroupAssignmentsComponent
      }
    ]
  },
  {
    path: 'local-students',
    component: LocalStudentManagementComponent,
    data: { title: 'Manage Local Students' }
  },
  {
    path: 'ward-directory',
    component: WardDirectoryComponent,
    data: { title: 'Ward Directory' }
  },
  {
    path: 'directory',
    component: WardDirectoryComponent,
    data: { title: 'Ward Directory', admin: true }
  },
  {
    path: 'campus-units-communications',
    component: CampusUnitsCommunicationsComponent,
    data: { title: 'Frequently Asked Questions' },
    children: [
      {
        path: 'new-question',
        data: { title: 'new-question-dialog', breadcrumb: 'Question' },
        component: NewQuestionDialogComponent
      },
      {
        path: 'new-section',
        data: { title: 'new-section-dialog', breadcrumb: 'Sections' },
        component: NewSectionDialogComponent
      }
    ]
  },
  {
    path: 'email',
    component: EmailComponent,
    data: {title: 'Manage Students | Email'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeaderRoutingModule {}
